export default __webpack_public_path__ + "static/media/approve.9ccbb92f.svg";